import { createContext, useContext, type ReactNode } from 'react';
import { useStore } from 'zustand';
import type { EstadoLicitacao, StoreLicitacao } from '../../application/licitacao-store';

const Contexto = createContext<StoreLicitacao | null>(null);

export function ProvedorLicitacao({ store, children }: { store: StoreLicitacao; children: ReactNode }) {
  return <Contexto.Provider value={store}>{children}</Contexto.Provider>;
}

/** Lê o estado da licitação aberta (os módulos só existem dentro de TelaLicitacao). */
export function useLicitacao<T>(seletor: (estado: EstadoLicitacao) => T): T {
  const store = useContext(Contexto);
  if (!store) throw new Error('ProvedorLicitacao ausente');
  return useStore(store, seletor);
}
